import { render } from "./JobSeekerDetails.vue?vue&type=template&id=275074e1&scoped=true"
import script from "./JobSeekerDetails.vue?vue&type=script&lang=js"
export * from "./JobSeekerDetails.vue?vue&type=script&lang=js"

import "./JobSeekerDetails.vue?vue&type=style&index=0&id=275074e1&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275074e1"]])

export default __exports__